import { render, staticRenderFns } from "./BasicPersonDisplayAndEdit.vue?vue&type=template&id=c1112b44&scoped=true&"
import script from "./BasicPersonDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./BasicPersonDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./BasicPersonDisplayAndEdit.vue?vue&type=style&index=0&id=c1112b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1112b44",
  null
  
)

export default component.exports